$(document).ready(function () {
  "use strict"; // Start of use strict

  // Configure tooltips for collapsed side navigation
  $('.navbar-sidenav [data-toggle="tooltip"]').tooltip({
    template: '<div class="tooltip navbar-sidenav-tooltip" role="tooltip" style="pointer-events: none;"><div class="arrow"></div><div class="tooltip-inner" style="width:170px;"></div></div>'
  });

  if (Cookies.get("sidenavOpen") === 'true') {
    openSidenav();
  } else {
    closeSidenav();
}

  function openSidenav() {
    $("body").removeClass("sidenav-toggled");
  }

  function closeSidenav() {
    $("body").addClass("sidenav-toggled");
  }

  // Toggle the side navigation
  $("#sidenavToggler").click(function(e) {
    e.preventDefault();
    $("body").toggleClass("sidenav-toggled");
    // $(".navbar-sidenav .nav-link-collapse").addClass("collapsed");
    // $(".navbar-sidenav .sidenav-second-level, .navbar-sidenav .sidenav-third-level").removeClass("show");
    if ($("body").hasClass('sidenav-toggled')) {
      Cookies.set('sidenavOpen', false, { expires: 7 });
    } else {
      Cookies.set('sidenavOpen', true, { expires: 7 });
    }
  });

  // Force the toggled class to be removed when a collapsible nav link is clicked
  $(".navbar-sidenav .nav-link-collapse").click(function(e) {
    e.preventDefault();
    $("body").removeClass("sidenav-toggled");
  });

  // Prevent the content wrapper from scrolling when the fixed side navigation hovered over
  $('body.fixed-nav .navbar-sidenav, body.fixed-nav .sidenav-toggler, body.fixed-nav .navbar-collapse').on('mousewheel DOMMouseScroll', function(e) {
    var e0 = e.originalEvent,
      delta = e0.wheelDelta || -e0.detail;
    this.scrollTop += (delta < 0 ? 1 : -1) * 30;
    e.preventDefault();
  });

  // Scroll to top button appear
  $(document).scroll(function(e) {
    var scrollDistance = $(this).scrollTop();
    if (scrollDistance > 100) {
      $('.scroll-to-top').fadeIn();
    } else {
      $('.scroll-to-top').fadeOut();
    }
  });

  // Configure tooltips globally
  $('[data-toggle="tooltip"]').tooltip({
    content: function () {
      return $(this).attr('title');
    }
  })

  $('a.scroll-to-top').click(function () {
     $('body,html').animate({ scrollTop: 0 }, 400);
     return false;
  });

  $('.gotop').click(function () {
    $('body,html').animate({scrollTop: 0 }, 500);
    return false;
  });



  $(document).on('mouseenter', '.js-ai-recommend-search', function() {
    let aiRecommend = $(this).closest('.ai-recommend')
    let popup = aiRecommend.find('.ai-recommend__popup')
    let screenHeight = window.innerHeight
    let positionTop = this.getBoundingClientRect().top - 300
    let aiRecommendContainer = $(this).closest('#recommendations-container')
    let aiRecommendCard = aiRecommend.find('.ai-recommend__card')
    let boxStarAfter = aiRecommend.find('.js-box-star-after')

    aiRecommendCard.css('background-color', '#f2f6fc')
    boxStarAfter.addClass('ai-recommend__box-star-after')

    while (positionTop + popup.height() >= screenHeight) {
      positionTop -= 26
    }

    if (positionTop < 100) positionTop = 14
    if (positionTop > 180) positionTop -= 12

    if (aiRecommendContainer.length) {
      let screenWidth = window.innerWidth
      let positionLeft = this.getBoundingClientRect().left - 10
      if (positionLeft + popup.width() >= screenWidth) positionLeft = positionLeft - popup.width() + 30
      popup.css({ left: positionLeft })
    } else {
      popup.css({ right: 110, left: 'unset' })
    }

    popup.css('top', `${positionTop}px`)
  });
});

// Show, hide news in dashboard
$(document).on('click', "#show-hide-all-news", function() {
  var $hidden_news = $(".hide-news");
  var display_label = $(this).data("label-display");
  var hide_label = $(this).data("label-hide");

  if ($hidden_news.hasClass('js-show')) {
    $hidden_news.removeClass('js-show');
    $hidden_news.fadeOut(1000);
    $(this).find('.btn').text(display_label);
  } else {
    $hidden_news.addClass('js-show');
    $hidden_news.fadeIn(1000);
    $(this).find('.btn').text(hide_label);
  }
});

$(document).on('click', ".popup_window", function() {
  window.open(this.href,"WindowName","width=800,height=600,resizable=yes,scrollbars=yes");
  return false;
});

$(document).on('change', ':file', function() {
  var files = !!this.files ? this.files : [];

  // no file selected
  if (files.length == 0) {
    $('.js-filename').val('');
    $('.imagePreview').hide();
    return;
  }

  // no FileReader support
  if (!window.FileReader) {
    $('.imagePreview').hide();
    return;
  }

  var filename = this.files[0].name;
  $('.js-filename').val(filename);

  if (/^image/.test( files[0].type)){ // only image file
    var reader = new FileReader(); // instance of the FileReader
    reader.readAsDataURL(files[0]); // read the local file
    reader.onloadend = function(){ // set image data as background of div
      $('.imagePreview').css("background-image", "url("+this.result+")").show();
    }
  }
});

$(document).on('submit', '.iform', function(){
  if($('.uploadFile')[0] && $('.uploadFile')[0].files.length == 0){
    alert(gon.error_messages['blank_image']);
    return false
  }
  return true;
});

$(document).on('focus', '#js-private-info', function(){
  clearPrivateInfo();
});

$(document).on('blur', '#js-private-info', function(){
  showPrivateInfo(this);
});


// A function to POST data through Javascript, without using standard Rails forms
// and also not using AJAX.
// (Modified)
// https://stackoverflow.com/questions/4583703/jquery-post-request-not-ajax


(function($) {
  $.extend({
    addParamsToForm: function($form, data) {

        var addData = function(name, data) {
          if ($.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
              var value = data[i];
              addData(name + '[]', value);
            }

            // For when the condition flags are empty.
            if(name.search("condition_flags") != -1 && data.length == 0){
              addData(name + '[]', 0);
            }
          } else if (typeof data === 'object') {
            for (var key in data) {
              if (data.hasOwnProperty(key)) {
                addData(name + '[' + key + ']', data[key]);
              }
            }
          } else if (data != null) {
            $form.append($('<input>').attr({
              type: 'hidden',
              name: String(name),
              value: String(data)
            }));
          }
        };

        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            addData(key, data[key]);
          }
        }
    }
  });
})($);


// For JSON blocks that have the "data-append-to-form-at-submit" (its value is a form selector)
// attribute, append all that JSON data (inside the block) to the form before submitting it.
$(document).ready(function(){
  const selectorAttr = "data-append-to-form-at-submit";

  $(`[${selectorAttr}]`).each((i, ele) => {
    const $dataBlock = $(ele);
    const data = JSON.parse($(ele).html());
    const selectorValue = $dataBlock.attr(selectorAttr);
    const $form = $(selectorValue);

    $form.submit(function(){
      // Append all data and submit.
      $.addParamsToForm($form, data);
    });
  });
});

function clearPrivateInfo(){
  var obj = document.getElementById('js-private-info')
  var info = obj.value;
  if(info == gon.private_info){
    obj.value = '';
  }
}

function showPrivateInfo(obj){
  var info = obj.value;
  if(info == ''){
    obj.value = gon.private_info;
  }
}
export { clearPrivateInfo };
